export default __webpack_public_path__ + "static/banner-socmed-desktop-299a5d97178cd2ffed5ad7fe745084dd.webp";